import { AppLocale, translate, useInterfaceLanguage } from '@/shared/i18n';

import { getLocaleBadge, getOnscreenDemoLocales } from '../../lib/getOnscreenDemoLocales';
import {
  SAvatar,
  SDivider,
  SDividerHandle,
  SDividerLine,
  SFrame,
  SHeading,
  SLanguageBadge,
  SLayer,
  SStep,
  SSteps,
  STranslatedLayer,
} from './styled';

const STEP_KEYS = [
  'editor.visualTranslation.paywall.demoUpload',
  'editor.visualTranslation.paywall.demoLanguage',
  'editor.visualTranslation.paywall.demoDownload',
] as const;

const SlideText = ({ locale }: { locale: AppLocale }) => (
  <>
    <SHeading>{translate(locale, 'editor.visualTranslation.paywall.demoTitle')}</SHeading>
    <SSteps>
      {STEP_KEYS.map((key) => (
        <SStep key={key}>{translate(locale, key)}</SStep>
      ))}
    </SSteps>
    <SAvatar />
  </>
);

// A slide before and after on-screen translation, wiping between the two: an illustration, so screen readers skip it.
export const OnscreenBeforeAfter = () => {
  const { locale } = useInterfaceLanguage();
  const { original, translated } = getOnscreenDemoLocales(locale);

  return (
    <SFrame data-testid="onscreen-before-after" aria-hidden>
      <SLayer data-testid="onscreen-before-after-original" lang={original}>
        <SLanguageBadge $side="left">{getLocaleBadge(original)}</SLanguageBadge>
        <SlideText locale={original} />
      </SLayer>

      <STranslatedLayer data-testid="onscreen-before-after-translated" lang={translated}>
        <SLanguageBadge $side="right">{getLocaleBadge(translated)}</SLanguageBadge>
        <SlideText locale={translated} />
      </STranslatedLayer>

      <SDivider>
        <SDividerLine />
        <SDividerHandle>
          <svg fill="none" height={14} viewBox="0 0 24 24" width={14}>
            <path
              d="M9 7l-5 5 5 5M15 7l5 5-5 5"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </SDividerHandle>
      </SDivider>
    </SFrame>
  );
};
